import store from './../../vuex/store'

export default {
  // =============从vuex中获取，如果vuex中没有，就去后台请求，存到vuex中（多模块之间数据共享，相同的数据不再重复请求）
  getAllAreas() {
    return new Promise((resolve, reject) => {
      let list = store.getters['common/areas']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('common/getAllAreas').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  // 从vuex中获取运营商
  getOperators() {
    return new Promise((resolve, reject) => {
      let operators = store.getters['common/operators']
      if (JSON.stringify(operators) === '[]') {
        store.dispatch('common/getOperators').then(res => {
          resolve(res)
        })
      } else {
        resolve(operators)
      }
    })
  },
  resetOperators() {
    store.dispatch('common/resetOperators')
  },
  getStations() {
    return new Promise((resolve, reject) => {
      let list = store.getters['common/stations']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('common/getStations').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  resetStations() {
    store.dispatch('common/resetStations')
  },
  getGroups() {
    return new Promise((resolve, reject) => {
      let list = store.getters['common/groups']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('common/getGroups').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  getGroupWithOperator() {
    return new Promise((resolve, reject) => {
      let list = store.getters['common/groupWithOperator']
      if (JSON.stringify(list) === '[]') {
        store.dispatch('common/getGroupWithOperator').then(res => {
          resolve(res)
        })
      } else {
        resolve(list)
      }
    })
  },
  resetGroups() {
    store.dispatch('common/resetGroups')
  }
}



// WEBPACK FOOTER //
// ./src/common/api/commonFromVuexApi.js